module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1-ed9357dabb62a47b44ef65f79378b10b.jpg";